import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const OwlMascot = ({ className = "" }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 140, damping: 15 });
  const sy = useSpring(my, { stiffness: 140, damping: 15 });
  const [blink, setBlink] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setBlink(true);
      setTimeout(() => setBlink(false), 190);
    }, 4200);
    return () => clearInterval(id);
  }, []);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set(((e.clientX - r.left) / r.width - 0.5) * 18);
    my.set(((e.clientY - r.top) / r.height - 0.5) * 14);
  };

  const onLeave = () => {
    mx.set(0);
    my.set(0);
  };

  const eye = (cx, key) => (
    <motion.g
      key={key}
      style={{ transformBox: "fill-box", transformOrigin: "center" }}
      animate={{ scaleY: blink ? 0.06 : 1 }}
      transition={{ duration: 0.16, ease: "easeInOut" }}
    >
      <circle cx={cx} cy={162} r={50} fill="#FDFBF7" />
      <circle cx={cx} cy={162} r={50} fill="none" stroke="#8A5A2E" strokeOpacity="0.15" strokeWidth="2" />
      <motion.g style={{ x: sx, y: sy }}>
        <circle cx={cx} cy={164} r={18} fill="#33251A" />
        <circle cx={cx + 6.5} cy={157} r={5.5} fill="#FDFBF7" />
      </motion.g>
    </motion.g>
  );

  return (
    <motion.div
      className={className}
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
      data-testid="owl-mascot"
    >
      <svg
        viewBox="0 0 340 360"
        className="w-full h-auto drop-shadow-2xl"
        role="img"
        aria-label="Chouette, le compagnon virtuel"
        onPointerMove={onMove}
        onPointerLeave={onLeave}
      >
        <circle cx="170" cy="186" r="164" fill="#EFE9DD" />
        <circle cx="170" cy="186" r="164" fill="none" stroke="#7FD6C2" strokeWidth="5" />
        <ellipse cx="170" cy="352" rx="88" ry="9" fill="#211A13" opacity="0.1" />
        <path d="M100 42 L138 76 L94 94 Z" fill="#8A5A2E" />
        <path d="M240 42 L246 94 L202 76 Z" fill="#8A5A2E" />
        <ellipse cx="170" cy="210" rx="112" ry="118" fill="#A9743F" />
        <path d="M64 200 Q52 258 92 294 Q104 254 90 196 Z" fill="#8A5A2E" />
        <path d="M276 200 Q288 258 248 294 Q236 254 250 196 Z" fill="#8A5A2E" />
        <ellipse cx="170" cy="268" rx="68" ry="56" fill="#F7EDD9" />
        <path d="M126 258 q22 14 44 0 q22 14 44 0" fill="none" stroke="#C89B6A" strokeWidth="5" strokeLinecap="round" opacity="0.7" />
        <path d="M134 284 q18 12 36 0 q18 12 36 0" fill="none" stroke="#C89B6A" strokeWidth="5" strokeLinecap="round" opacity="0.55" />
        <rect x="86" y="102" width="68" height="12" rx="6" fill="#8A5A2E" transform="rotate(-9 120 108)" />
        <rect x="186" y="102" width="68" height="12" rx="6" fill="#8A5A2E" transform="rotate(9 220 108)" />
        {eye(126, "eye-left")}
        {eye(214, "eye-right")}
        <path d="M170 194 L150 216 Q170 236 190 216 Z" fill="#F2A33C" />
        <ellipse cx="140" cy="330" rx="15" ry="7" fill="#F2A33C" />
        <ellipse cx="200" cy="330" rx="15" ry="7" fill="#F2A33C" />
      </svg>
    </motion.div>
  );
};

export default OwlMascot;